export type ScrapingStatus = 'ok' | 'blocked' | 'unreachable' | 'partial';

export interface IEnrichedField {
  value: string[]; // always array; text fields have one element
  confidence?: number; // 0.0–1.0, optional
}

export interface IAiEnrichmentResult {
  scrapingStatus?: ScrapingStatus;
  dataProcessor?: IEnrichedField | null;
  descriptionOfService?: IEnrichedField | null;
  nameOfProcessingCompany?: IEnrichedField | null;
  addressOfProcessingCompany?: IEnrichedField | null;
  dataProtectionOfficer?: IEnrichedField | null;
  privacyPolicyURL?: IEnrichedField | null;
  cookiePolicyURL?: IEnrichedField | null;
  optOutUrl?: IEnrichedField | null;
  dataRecipientsList?: IEnrichedField | null;
  dataPurposesList?: IEnrichedField | null;
  dataCollectedList?: IEnrichedField | null;
  locationOfProcessing?: IEnrichedField | null;
  thirdCountryTransfer?: IEnrichedField | null;
  retentionPeriodDescription?: IEnrichedField | null;
  technologyUsed?: IEnrichedField | null;
  legalBasisList?: IEnrichedField | null;
  defaultCategorySlug?: IEnrichedField | null;
}

// Tag fields that store string[] in form state
export const TAG_FIELDS = new Set([
  'dataPurposesList',
  'dataCollectedList',
  'locationOfProcessing',
  'thirdCountryTransfer',
  'technologyUsed',
  'legalBasisList',
]);
